import { jsx } from "react/jsx-runtime";
import "react";
import { Disc } from "./Disc.js";
import { discGroupVariants } from "./DiscGroup.variants.js";
const DiscGroup = ({ alt = '', contentData, isVertical, size })=>{
    const { baseSlot, discSlot } = discGroupVariants({
        isVertical,
        size
    });
    return /*#__PURE__*/ jsx("div", {
        className: baseSlot(),
        children: contentData.map((contentItem, index)=>{
            const { content, contentType, emphasis, palette } = contentItem;
            const isLastDisc = index === contentData.length - 1;
            const hasMask = !isLastDisc;
            const marginClass = 0 === index ? '' : discSlot();
            return /*#__PURE__*/ jsx("div", {
                className: marginClass,
                children: /*#__PURE__*/ jsx(Disc, {
                    alt: alt ? `${alt}-${index}` : void 0,
                    isVertical: isVertical,
                    hasMask: hasMask,
                    content: content,
                    contentType: contentType,
                    emphasis: emphasis,
                    palette: palette,
                    size: size
                })
            }, `${contentType}-${index}`);
        })
    });
};
export { DiscGroup };
